import React from 'react'
import { AlertTriangleIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Blanket } from '@/shared/components/ui/blanket'
import {
	Empty,
	EmptyDescription,
	EmptyHeader,
	EmptyMedia,
} from '@/shared/components/ui/empty'
import { cn } from '@/shared/lib/utils'

export default function WidgetErrorState({
	isTinted,
	size = 'medium',
}: {
	isTinted?: boolean
	size?: 'small' | 'medium'
}) {
	const { t } = useTranslation()

	return (
		<Blanket
			className='absolute flex items-center justify-center rounded-xl bg-white/50 backdrop-blur-lg dark:bg-black/50'
			isTinted={isTinted}
		>
			<Empty className='md:px-4'>
				<EmptyHeader>
					<EmptyMedia
						variant='icon'
						className='bg-destructive/20 text-destructive'
					>
						<AlertTriangleIcon />
					</EmptyMedia>
					<EmptyDescription
						className={cn('text-destructive', {
							'text-xs': size === 'small',
						})}
					>
						{t('error.unrecoverable.title')}
					</EmptyDescription>
				</EmptyHeader>
			</Empty>
		</Blanket>
	)
}
